import { render, staticRenderFns } from "./BackHome.vue?vue&type=template&id=21355d90&scoped=true&"
import script from "./BackHome.vue?vue&type=script&lang=js&"
export * from "./BackHome.vue?vue&type=script&lang=js&"
import style0 from "./BackHome.vue?vue&type=style&index=0&id=21355d90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21355d90",
  null
  
)

export default component.exports